import { PrimaryButton, Stack } from "@fluentui/react";
import { useState } from "react";
import LoginButton from "./components/LoginButton";
import { backendRequestJson } from "./shared/backend";
import { useMsal } from "@azure/msal-react";

const LoggedOutLayout = () => {
  const [loginError, setLoginError] = useState(null);

  const { accounts } = useMsal();

  return (
    <Stack
      horizontalAlign="center"
      verticalAlign="center"
      styles={{ root: { height: "100vh", width: "100vw" } }}
      tokens={{ childrenGap: "1em" }}
    >
      <Stack.Item>
        <h2>Welcome! Please sign in.</h2>
      </Stack.Item>
      <Stack.Item>
        <LoginButton
          text="Sign In [current account]"
          setLoginError={setLoginError}
          iconProps={{ iconName: "Signin" }}
        />
      </Stack.Item>
      <Stack.Item>
        <LoginButton
          text="Sign In [select an account]"
          setLoginError={setLoginError}
          iconProps={{ iconName: "Signin" }}
          forceSelectAccount={true}
        />
      </Stack.Item>
      <Stack.Item>
        <PrimaryButton
          text="GET /status"
          onClick={() => {
            backendRequestJson("GET", "/status")
              .then((data) => {
                console.log("GET /status [OK]:", data);
              })
              .catch((error) => {
                console.error("GET /status [FAILED]:", error);
              });
          }}
        />
      </Stack.Item>
      <Stack.Item>
        <PrimaryButton
          text="check msal status"
          onClick={() => {
            console.log("MSAL accounts: ", accounts);
          }}
        />
      </Stack.Item>

      {loginError ? (
        <Stack.Item>
          <Error error={loginError} />
        </Stack.Item>
      ) : null}
      {loginError && loginError.includes("interaction_in_progress") ? (
        <Stack.Item>
          <PrimaryButton
            text="Clear browser storage"
            onClick={() => {
              clearAllStorage();
            }}
          />
        </Stack.Item>
      ) : null}
    </Stack>
  );
};

function Error({ error }) {
  return (
    <div
      style={{
        backgroundColor: "red",
        color: "white",
        padding: "1em",
        fontWeight: "500",
      }}
    >
      <b>Error:</b> {error}
    </div>
  );
}

const clearAllStorage = () => {
  sessionStorage.clear();
  localStorage.clear();

  document.cookie.split(";").forEach((cookie) => {
    document.cookie = cookie
      .replace(/^ +/, "")
      .replace(/=.*/, "=;expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/");
  });
};

export default LoggedOutLayout;
